import clsx from "clsx";

export const BUTTON_VARIANTS = {
  primary:
    "bg-primary-500 hover:bg-primary-600 text-white shadow-raro hover:shadow-raro-lg",
  secondary:
    "bg-white border-2 border-primary-500 text-primary-500 hover:bg-primary-50",
  danger: "bg-red-500 hover:bg-red-600 text-white",
  ghost: "bg-transparent text-primary-500 hover:bg-primary-50",
  outline: "bg-transparent border-2 border-gray-300 text-gray-700 hover:bg-gray-50 hover:border-gray-400",
} as const;

export const BUTTON_SIZES = {
  sm: "px-3 py-1.5 text-sm",
  md: "px-4 py-2 text-base",
  lg: "px-6 py-3 text-lg",
} as const;

export function getButtonClasses(
  variant: keyof typeof BUTTON_VARIANTS,
  size: keyof typeof BUTTON_SIZES,
  disabled?: boolean,
  loading?: boolean
): string {
  return clsx(
    // Classes base
    "font-montserrat font-semibold rounded-xl transition-all duration-200",
    "focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500",
    "inline-flex items-center justify-center",

    // Variantes e tamanhos
    BUTTON_VARIANTS[variant],
    BUTTON_SIZES[size],

    // Estados
    {
      "opacity-50 cursor-not-allowed": disabled,
      "transform hover:active:scale-95": !disabled && !loading,
    }
  );
}
